// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ps-hero-body{display:table;margin:0 auto;width:100%}@media screen and (max-width:768px){.ps-hero-body{padding:0 15px}}@media print,screen and (min-width:769px){.ps-hero-body{padding:0 50px}}@media screen and (min-width:1024px){.ps-hero-body{padding:0 100px}}.ps-hero-body .container{display:table-cell;vertical-align:middle}@media print,screen and (min-width:769px){.ps-hero-body{height:90vh}}.quote-process-layout #launcher{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
